import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'toaster-component',
    templateUrl: 'toasterComponent.html'
})

export class ToasterComponent {

    constructor(
        public toastr: ToastrService
    ) {

    }
    public setViewRef(vcr) {
        // this.toastr.setRootViewContainerRef(vcr);
    }

    public showSuccess(msg) {
        this.toastr.success('<span style="color: white">' + msg + '</span>', null,
           );
    }

    public showError(msg) {
        this.toastr.error('<span style="color: white">' + msg + '</span>', null,
           );
    }

    public showWarning(msg) {
        this.toastr.warning('<span style="color: white">' + msg + '</span>',
            null, { enableHtml: true });
    }

    public showInfo(msg) {
        this.toastr.info('<span style="color: white">' + msg + '</span>',
            null, { enableHtml: true });
    }
}


// WEBPACK FOOTER //
// ./src/app/toasterComponent/toasterComponent.ts